import React, { useState } from 'react'
import { Box, Text, getPaletteColor } from 'pcln-design-system'
import { NotificationImage } from '@pcln/notification'
import styled from 'styled-components'
import { getPhoneNumber } from '../../util/phoneSalesBanner/phoneSalesBanner'
import { PhoneSalesFlyInIcon } from '@pcln/phone-sales-banner'

const StyledBox = styled(Box)`
  display: none;
  ${(props) => props.theme.flyQueries.tablet} {
    display: block;
  }
`
const PhoneLink = styled.a`
  text-decoration: none;
  color: ${getPaletteColor('primary.base')};
`

const PhoneSalesFlyIn = ({ isDesktop, searchRefId, phoneBookInfo }) => {
  const [showBanner, setShowBanner] = useState(true)

  const dismissBanner = () => {
    setShowBanner(false)
  }

  const headerContent = () => {
    return (
      <Text mr={3} bold color='text.base'>
        Priceline Phone Deals
      </Text>
    )
  }

  const bodyContent = () => {
    const phoneNumber = phoneBookInfo?.phoneNumber || getPhoneNumber(!isDesktop, searchRefId)
    return (
      <Box mr={'40px'}>
        <Text regular>Book with an agent for great rates!</Text>
        <Text mt={'8px'}>Call now!</Text>
        <Text bold textAlign={'left'} fontSize={[0, 1]}>
          <PhoneLink href={`tel:${phoneNumber}`}>{phoneNumber}</PhoneLink>
        </Text>
      </Box>
    )
  }

  if (showBanner && isDesktop) {
    return (
      <StyledBox>
        <NotificationImage
          data-test='phone-sales-flyin'
          renderHeaderContent={headerContent}
          renderDynamicContent={bodyContent}
          handleCloseClick={dismissBanner}
          animationStickinessDelay={0.3}
          persist
          imageIcon={PhoneSalesFlyInIcon}
          leftBarColor={'secondary.base'}
          bottom
        />
      </StyledBox>
    )
  }
  return null
}

export { PhoneSalesFlyIn }
